import HeaderSearch from './HeaderSearch'

export default function install(Vue) {
  Vue.component(HeaderSearch.name, HeaderSearch)
}
